import RoundBullet from "./RoundBullet";

export default RoundBullet;
